module.exports = __webpack_public_path__ + "assets/img/menu-stats.f810624f.svg";